import React, {useState, useEffect} from 'react';
import './CompanyForm.css';
import wykrz from '../../../img/wykrz.svg';
import red_line from '../../../img/red_line.png';
import { useDispatch, useSelector } from 'react-redux';
import { setComplaintType, setCustomerType } from "../../../features/customer/customerSlice";
import {customerSlice, setUserParams} from '../../../features/customer/customerSlice';
import { setCompanyParams } from '../../../features/customer/companySlice';
import { targetCustomerSlice,setTargetCustomerParams } from '../../../features/customer/targetCustomerSlice';
import { updateCustomerData } from '../../../features/customer/customerSlice';
import { useNavigate } from 'react-router-dom'; 
import { setSelectedRow, setSearchValue } from '../../../features/customer/companySlice';
import { getCompanyByTaxId, getCompanyByText, getMainCustomersByTaxId } from '../../../features/customer/companySlice';
import { CompanySearchInput } from '../../companySearch/CompanySearchInput';
import { IS_INTERNAL_APP } from '../../../api/ApiSettings';
import { Dialog } from '../../common/dialog/Dialog';
import { FooterButtons } from '../../common/buttons/FooterButtons';

export const CompanyForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const company = useSelector((state)=>state.company.companies);
  const complaintType = useSelector((state) => state.complaint.complaintType);
  const selectedRow = useSelector((state)=>state.company.selectedRow);
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const [showCustomerForm, setShowCustomerForm] = useState(false);
  const companyType = useSelector((state)=>state.customer.type[0]);
  const customer = useSelector(state=>state.customer)
  const targetCustomer  = useSelector(state=>state.targetCustomer);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [selectCode, setSelectCode] = useState('');
  const complaintTypeName = useSelector((state)=>state.complaint.complaintType.name);
  const [errors, setErrors] = useState({
    customerPersonName:false,
    email:false,
    phone: false,
});
const userData = useSelector(state => state.customer);
const [nameValue, setNameValue] = useState(targetCustomer.customerPersonName);
const [emailValue, setEmailValue] = useState(targetCustomer.email);
const [phoneValue, setPhoneValue] = useState(targetCustomer.phone);
const [isCompanyFound, setIsCompanyFound] = useState(false);
const [canProceed, setCanProceed] = useState(true);

const emailRegex = /^\S+@\S+\.\S+$/;
const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
const postaCodeRegex = /^[0-9]{2}-[0-9]{3}$/;
const validate = (name, value) => {
    switch (name) {
        case "customerPersonName":
            return value !== "";
        case "email":
            return emailRegex.test(value);
        case "phone":
            return phoneRegex.test(value);
        default:
            return true;
    }
}

const handleNextClick = (option) => {
  const input = document.querySelectorAll('input');
  let formValid = true;
  let userData = {};

  input.forEach(input => {
    if (input.name === 'name' && !input.value.trim()) {
      formValid = false;
    } else if (!validate(input.name, input.value)) {
      formValid = false;
    } else {
      userData[input.name] = input.value;
    }
  });

  if (!formValid) {
    setErrors({
      customerPersonName: !userData.customerPersonName,
      email: !userData.email,
      phone: !userData.phone,
    });
    return;
  }

  
  if(IS_INTERNAL_APP === false){
    setErrors({
        name: false,
        email: false,
        phone: false,
        });}
        dispatch(customerSlice.actions.updateCustomerData(selectedRow));
        dispatch(customerSlice.actions.updateCustomerData({email:emailValue, phone:phoneValue}));
        dispatch(targetCustomerSlice.actions.setTargetCustomerParams({customerPersonName: nameValue, email:emailValue, phone:phoneValue}));
        
            const isSpecialComplaintType =
            complaintTypeName === 'Warranty' ||
            complaintTypeName === 'DeliveryMismatch' ||
            complaintTypeName === 'TransportDamage';

          const isFCodeSelectedRow = selectedRow.code.startsWith('F_');
          const shouldShowDialog = (isFCodeSelectedRow && isSpecialComplaintType) || (selectedRow.code === '' && isFCodeSelectedRow === false && isSpecialComplaintType);
          if (shouldShowDialog) {
            setShowDialog(true);
          } else if(formValid === true){
            setCurrentPage('companyRegistration');
            navigate('/companyRegistration');
          }else if (IS_INTERNAL_APP === true)
          {
            setCurrentPage('companyRegistration');
            navigate('/companyRegistration');
          }
          
        dispatch(setComplaintType(companyType));
        dispatch(setCustomerType({id: companyType.customerId}));
    }


    const handleChange = (event) => {
            const { name, value } = event.target;
    switch (name) {
        case "customerPersonName":
            setNameValue(value);
            break;
        case "email":
            setEmailValue(value);
            break;
        case "phone":
            setPhoneValue(value);
            break;
        default:
            break;
        }
        setErrors({
            ...errors,
            [name]: !validate(name, value)
    });

    }
    const handleBackClick = () =>{
      setCurrentPage('customers');
      navigate('/customers'); 

    }


  const handleOpenDialog = () =>{
    setIsDialogOpen(true);
};

const handleCloseDialog = () =>{
    setIsDialogOpen(false);
};


  return (
    <div className='company-form-container'>
    <CompanySearchInput 
      showDialog={showDialog}
      selectCode={selectCode} 
      setShowDialog={setShowDialog} 
      setSelectCode={setSelectCode} 
      isCompanyFound={isCompanyFound} 
      setIsCompanyFound={setIsCompanyFound}/>
    
     <div className='company-container'>
    {selectedRow &&
    <div>
    <div className='company-search-data-container'>
        <div>
          <label>Nazwa firmy</label>
          <input type='text' className='company-form-text-field' defaultValue={selectedRow.companyName} readOnly/>
        </div>
        <div>
          <label>Ulica</label>
          <input type='text' className='company-form-text-field' defaultValue={selectedRow.street} readOnly/>
        </div>
        <div>
          <label>Nr budynku</label>
          <input type='text' className='company-form-text-field' defaultValue={selectedRow.buildingNumber} readOnly/>
        </div>
        <div>
          <label>Nr lokalu<p className='optional' style={{top: '0px', display: 'inline',left: '10px'}}>Opcjonalnie</p></label>
          <input type='text' name='flatNumber' className='company-form-text-field' defaultValue={selectedRow.flatNumber}/>
        </div>
        <div>
          <label>Kod pocztowy</label>
          <input type='text' className='company-form-text-field' defaultValue={selectedRow.postalCode} readOnly/>
        </div>
        <div>
          <label>Miejscowość</label>
          <input type='text' className='company-form-text-field' defaultValue={selectedRow.city} readOnly/>
        </div>
        <div>
          <label>Kraj</label>
          <select className='company-form-text-field' defaultValue='Polska'>
            <option disabled>Polska</option>
          </select>
        </div>
        <div className='information-text-container'>
          <img src={wykrz} className='information-img'/>
          <p className='information-text'><b>Miejsce odbioru zgłaszanego produktu wskażesz <br/>w kolejnych krokach.</b></p>
        </div>
    </div>
  
   
        <div className='reporting-person-container'>
            <div className='reporting-person-title'>
            <img style={{marginLeft: "0px"}} src={red_line} className='red-line'/>
            <p className='reporting-person-title-text'>Dane osoby zgłaszającej</p>
            </div>
            <div className='reporting-person-field-container'>
              <div>
              <label style={errors.customerPersonName ? {color: "red"}: {}}>Imię i nazwisko</label>
                <input type="text" name="customerPersonName" className='reporting-person-field' value={nameValue}  onChange={handleChange} style={errors.customerPersonName ? {borderColor: "red"}: {}} />
                {errors.customerPersonName && <p className="error">Pole obowiązkowe</p>}
              </div>
              <div>
              <label style={errors.email ? {color: "red"}: {}}>E-mail</label>
                <input type="email" name="email" className='reporting-person-field' value={emailValue} onChange={handleChange} style={errors.email ? {borderColor: "red"}: {}}/>
                {errors.email && <p className = "error">Podany adres e-mail jest nieprawidłowy</p>}
              </div>
              <div>
              <label style={errors.phone ? {color: "red"}: {}}>Telefon</label>
                <input type="tel" name="phone" className='reporting-person-field' value={phoneValue} onChange={handleChange} style={errors.phone ? {borderColor: "red"}: {}}/>
                {errors.phone && <p className="error">Podany numer telefonu jest niepoprawny</p>}
              </div>
            <div>
            <button onClick={handleOpenDialog} className="rodo-btn">Wyświetl klauzulę RODO</button>
            <Dialog isOpen={isDialogOpen} onClose={handleCloseDialog}>
                <p style={{fontFamily:'Montserrat'}}><h4>Klauzula informacyjna RODO</h4><br/>
                   <strong>Zgodnie z art. 13 ust. 1 i ust. 2 ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r. informuję, iż:</strong><br/>
                   <ol>
                   1. administratorem Pani/Pana danych osobowych jest PRO sp. z o.o. z siedzibą w Bielsko-Biała ul. Strażacka 76;<br/>
                   2. kontakt z powołanym przez PRO sp. z o.o. inspektorem ochrony danych pod adresem e-mail: iod@poziomnica.pl;<br/>
                   3. Pani/Pana dane osobowe przetwarzane będą w celu:<br/>
                   <ul>
                   <li>w celach wynikających z prawnie uzasadnionych interesów realizowanych przez PRO sp. z o.o. jako administratora danych (podstawa prawna art. 6 ust. 1 lit. f RODO);</li>
                   <li>w celu wykonywania umów zawieranych przez PRO sp. z o.o. z klientami (podstawa prawna art. 6 ust. 1 lit. b RODO);</li>
                   <li>w celu prowadzenia rekrutacji osób zainteresowanych pracą PRO sp. z o.o. (podstawa prawna art. 6 ust. 1 lit. a RODO).</li>
                   </ul>
                   4. Przetwarzamy dane osobowe również w zakresie wypełnienia obowiązków prawnych ciążących na PRO sp. z o.o. (podstawa prawna art. 6 ust. 1 lit. c RODO).Pani/Pana dane osobowe będą przechowywane do momentu wycofania zgody/zakończenia współpracy;<br/>
                   5. posiada Pani/Pan prawo dostępu do treści swoich danych oraz prawo ich sprostowania, usunięcia, ograniczenia przetwarzania, prawo do przenoszenia danych, prawo wniesienia sprzeciwu, prawo do cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania , którego dokonano na podstawie zgody przed jej cofnięciem;<br/>
                   6. ma Pani/Pan prawo wniesienia skargi do PUODO gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy ogólnego rozporządzenia o ochronie danych osobowych z dnia 27 kwietnia 2016 r.<br/>
                    </ol>
                </p>
            </Dialog>
            </div>
            </div>
           
        </div>
        <div className="company-btn-container">
          <button className="company-btn-prev" onClick={handleBackClick}><p>Wróć</p></button>
          <button className="company-btn-next" onClick={handleNextClick}><p>Dalej</p></button>
        </div>
        </div>}
         {showDialog === true && (
            <Dialog isOpen={showDialog} onClose={()=>setShowDialog(false)}>
              <ol>
              <ul>
              <li>Państwa firma nie jest uprawniona do składania reklamacji <b>z tytułu rękojmi</b>, proszę zgłosić się z reklamacją do sprzedawcy u którego został dokonany zakup.</li>
              <li>Państwa firma nie jest uprawniona do składania reklamacji <b>z tytułu uszkodzenia transportowego</b>, proszę zgłosić się z reklamacją do sprzedawcy u którego został dokonany zakup.</li>
              <li>Państwa firma nie jest uprawniona do składania reklamacji <b>z tytułu niezgodności w dostawie</b>, proszę zgłosić się z reklamacją do sprzedawcy u którego został dokonany zakup.</li>
              </ul>
              </ol>
            </Dialog>)}
        </div>
  </div>
  )
}
